import { useEffect, useState } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Input } from '@/components/ui/input';
import { Search, History, Shield, Info, AlertTriangle } from 'lucide-react';

// Note: This uses a new endpoint that reads training-related AuditLogs
// For now, we display a filtered view from the existing audit infrastructure

export default function AuditHistorySection() {
  return (
    <div>
      <h2 className="text-lg font-bold text-foreground flex items-center gap-2 mb-4">
        <History className="w-5 h-5" /> Audit History
      </h2>

      <div className="bg-muted/30 border border-border rounded-xl p-6 text-center">
        <Shield className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
        <h3 className="font-semibold text-foreground mb-2">Training Audit Trail</h3>
        <p className="text-sm text-muted-foreground max-w-md mx-auto mb-4">
          All training actions are automatically logged to the audit system. This includes course edits, enrolments, quiz submissions, assessment sign-offs, certificate generation and policy changes.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-lg mx-auto mt-4">
          <div className="bg-card border border-border rounded-lg p-3 text-center">
            <Info className="w-5 h-5 text-primary mx-auto mb-1" />
            <p className="text-xs font-medium text-foreground">Quiz Submissions</p>
            <p className="text-[10px] text-muted-foreground">Scores, attempts, pass/fail</p>
          </div>
          <div className="bg-card border border-border rounded-lg p-3 text-center">
            <Shield className="w-5 h-5 text-primary mx-auto mb-1" />
            <p className="text-xs font-medium text-foreground">Assessments</p>
            <p className="text-[10px] text-muted-foreground">Sign-offs, evidence, outcomes</p>
          </div>
          <div className="bg-card border border-border rounded-lg p-3 text-center">
            <AlertTriangle className="w-5 h-5 text-primary mx-auto mb-1" />
            <p className="text-xs font-medium text-foreground">Course Changes</p>
            <p className="text-[10px] text-muted-foreground">Edits, versioning, status</p>
          </div>
        </div>
        <p className="text-xs text-muted-foreground mt-4 italic">
          Full searchable audit log viewer with date filtering and CSV export is available in the main Admin Panel → Reports Centre.
        </p>
      </div>
    </div>
  );
}
